// extracted by mini-css-extract-plugin
export default {"form":"Vzd3PAy5sVsdf21jf91g__form___","mentionsAwardsWrapper":"PF5T9TmGRnY9sB9pcYyb__mentionsAwardsWrapper___"};